import t, { useState as p } from "react";
import { useTranslation as u } from "react-i18next";
import { Modal as f } from "../Modal/Modal.js";
import e from "./modalLinks.module.scss.js";
function L({
  links: m,
  design: o = {
    color: "#242323",
    backgroundColor: "#FFF"
  }
}) {
  if (m.length === 0)
    return null;
  const { t: a } = u(), [l, c] = p({
    open: !1,
    title: "",
    content: ""
  });
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "modal-links", className: e.modalLinks }, /* @__PURE__ */ t.createElement("div", { className: e.modalLinks__items }, m.map(({ key: r, value: n }) => /* @__PURE__ */ t.createElement(
    "span",
    {
      key: r,
      title: a(r) || "",
      className: "modalLink",
      style: {
        color: o == null ? void 0 : o.color,
        borderBottomColor: o == null ? void 0 : o.color
      },
      onClick: () => c({
        open: !0,
        title: a(r),
        content: n
      })
    },
    a(r)
  ))), /* @__PURE__ */ t.createElement(
    f,
    {
      show: l.open,
      onClose: () => c({
        ...l,
        open: !1
      }),
      design: {
        backgroundColor: o == null ? void 0 : o.backgroundColor,
        textColor: o == null ? void 0 : o.color,
        fontFamily: o == null ? void 0 : o.fontFamily
      },
      title: l.title,
      overflowContent: !0
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: e.modalLinks__modal,
        dangerouslySetInnerHTML: {
          __html: l.content
        }
      }
    )
  ));
}
export {
  L as ModalLinks
};
//# sourceMappingURL=ModalLinks.js.map
